module.exports = __webpack_public_path__ + "static/img/quxiaojingyin.4586d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quxiaojingyin.png
// module id = 8ZlW
// module chunks = 24